import colorString from "color-string";

const BANNED_COLORS = ["#FFFFFF"];

const extractHEXColors = template => {
  return (
    (template.match(/#[0-9a-f]{3,6}/gi) || []).map(s => s.toUpperCase()) || []
  );
};

const extractRGBColors = template => {
  return template.match(/(?:rgb|hsl)a?\([^\)]*\)/gi) || [];
};

const convertRGBtoHEX = rgbColors => {
  return rgbColors.map(color => {
    const rgb = colorString.get.rgb(color);
    return colorString.to.hex(rgb);
  });
};

const combineColors = (rgbColors, hexColors) => {
  const convertedColors = convertRGBtoHEX(rgbColors);
  const combinedColors = [...convertedColors, ...hexColors];
  return combinedColors
    .filter(c => !BANNED_COLORS.includes(c))
    .reduce((r, c) => ((r[c] = (r[c] || 0) + 1), r), {});
};

const sortColorByUsage = colors => {
  let keys = Object.keys(colors);
  const sortedColors = keys
    .sort((a, b) => {
      return colors[a] - colors[b];
    })
    .reverse();
  return Object.values(sortedColors);
};

const usedColors = ({ sections = window.store.getState().sections }) => {
  const templateStr = JSON.stringify(sections);
  const hexColors = extractHEXColors(templateStr);
  const rgbColors = extractRGBColors(templateStr);
  const usedColors = combineColors(rgbColors, hexColors);
  return sortColorByUsage(usedColors);
};
export default usedColors;
